import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import ShowToast from '../../../../Components/ShowToast';
import { authAxiosWithBearer, baseURL } from '../../../../baseURL';

const SRIssueFormHandleCom = ({requisionItemDatas,srID,ticket}) => {
    const navigate = useNavigate()

    const [requisionItemOptions, setRequisionItemOptions] = useState([]);
    const [selectedRequisionItem, setSelectedRequisionItem] = useState([]);
    const [requisionIssueRequiredMessage,setRequisionIssueRequiredMessage]=useState('')
    const [isLoading, setIsLoading] = useState(false)


    const [requisionIssueFormData, setRequisionIssueFormData] = useState({
        diagnosis_sr: null,
        ticket_text : '',
        srissueditem_set: [
          {
            diagnosis_sr_item: null,
            issue_qty:'',
            max_issue_qty:'',
            remarks:'',
            item:null,
            item_id:null,
            stock_available_qty:''
          },
        ],
    });



    useEffect(()=>{
        const options = requisionItemDatas
        .filter((data)=>data?.available_issue_quantity > 0)
        .map((data) => ({
            value: data.id,
            label: `${data?.item_name} | ${data?.item_size} | ${data.item_brand}`,
            item: data.item,
            uom: data.uom_text,
            quantity:data.quantity,
            max_issue_qty:data.available_issue_quantity,
            stock_available_qty:data.item_stock_available_qty
        }));
        setRequisionItemOptions(options);
    },[requisionItemDatas])
    


    const handleRequisionItemChange = (selectedOption, index) => {
        const updatedFormData = { ...requisionIssueFormData };
        
        // Reset issue_qty and stock when the item selection changes
        updatedFormData.srissueditem_set[index] = {
            diagnosis_sr_item: selectedOption?.value || null,
            issue_qty: selectedOption?.max_issue_qty || '',
            uom: selectedOption?.uom || '',
            item: selectedOption?.item || '',
            item_id: selectedOption?.item || '',
            max_issue_qty: selectedOption?.max_issue_qty || '',
            stock_available_qty: selectedOption?.stock_available_qty || '',
        };
        
        const updatedSelectedRequisionItem = [...selectedRequisionItem];
        updatedSelectedRequisionItem[index] = selectedOption || null;
        

        setSelectedRequisionItem(updatedSelectedRequisionItem);
        setRequisionIssueFormData(updatedFormData);
    };
        

    const handleRequisionIssueInputChange = (e, index, type) => {
        const updatedData = { ...requisionIssueFormData };
        const { name } = e.target;
        let value = e.target.value;  
      
        if (type === 'srissueditem_set' && name === 'issue_qty') {
          const parts = value.split('.');
          const integerPart = parts[0];
          const decimalPart = parts[1] || '';
      
          if (integerPart.length > 12) {
            ShowToast('error', `Ensure that there are no more than 12 digits`);
            return;
          }
      
          if (parts.length === 2) {
            value = `${integerPart}.${decimalPart.slice(0, 2)}`;
      
            if (decimalPart.length > 2) {
              ShowToast('error', `More than 2 digits after the decimal point for ${name}.`);
            }
          }
        }
      
        if (type === 'srissueditem_set') {
          setRequisionIssueRequiredMessage('');
          updatedData.srissueditem_set[index][name] = value;
        } else {
          updatedData[name] = value;
        }
      
        setRequisionIssueFormData(updatedData);
      };
      
    
    const areAllFieldsFilled = () => {
        return (
            requisionIssueFormData.srissueditem_set &&
            requisionIssueFormData.srissueditem_set.every((item) => {
                return item?.diagnosis_sr_item !== null && item?.issue_qty !== '';
            })
        );
    };
    
      
    const handleAddRequisionIssueItem = () => {
        if (areAllFieldsFilled()) {
            setRequisionIssueFormData((prevState) => ({
                ...prevState,
                srissueditem_set: [
                    ...prevState.srissueditem_set,
                    {
                        diagnosis_sr_item: null,
                        issue_qty:'',
                        stock:null,
                    },
                ],
            }));
            setRequisionIssueRequiredMessage('');
        } else {
            setRequisionIssueRequiredMessage("Please fill all fields in the existing field before adding a new one.");
        }
    };
    

    const handleRemoveRequisionIssueItem = (index) => {
      // Create a copy of the damagepartsitem_set array
      const srissueditem_set = [...requisionIssueFormData.srissueditem_set];
    
      const lastIndex = srissueditem_set.length - 1;

      console.log('lastIndex',lastIndex)

      const lastItemIsNull = srissueditem_set[lastIndex] && srissueditem_set[lastIndex].diagnosis_sr_item === null;
      
  
      if (index === lastIndex) {
        srissueditem_set.splice(lastIndex, 1);
      } 
      else if (index !== lastIndex && lastItemIsNull) {
        ShowToast('error','Cannot delete this item because last item is null.');
        return;
      }
      else if (index !== lastIndex && lastItemIsNull === false) {
        srissueditem_set.splice(index, 1);
      }
    
      const updatedSelectedItem = selectedRequisionItem.filter((_, i) => i !== index);
    
      setRequisionIssueRequiredMessage('');
    
      setRequisionIssueFormData({
        ...requisionIssueFormData,
        srissueditem_set,
      });
      setSelectedRequisionItem(updatedSelectedItem);
    };
    



    const handleRequisionIssueSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true)
        try {
          const updatedFormData = {
            ...requisionIssueFormData,
            diagnosis_sr: srID,
            ticket_text: ticket,
          };
      
          const response = await authAxiosWithBearer.post(`${baseURL}/inventory/api/sr-issued/`, updatedFormData);
      
          if (response) {
            ShowToast('success', 'Successfully Submit');
            navigate('/sr-list');
          }
        } catch (error) {
          console.log(error);
          if(error.response.data.error){
            ShowToast('error', `${error.response.data.error}`);
          }else{
            ShowToast('error', 'Something is wrong');
          }
        }finally{
        setIsLoading(false)
        }
      };

      
  return {
    requisionItemOptions,
    setRequisionItemOptions,
    selectedRequisionItem,
    setSelectedRequisionItem,
    requisionIssueRequiredMessage,
    setRequisionIssueRequiredMessage,
    requisionIssueFormData,
    setRequisionIssueFormData,
    handleRequisionItemChange,
    handleRequisionIssueInputChange,
    handleAddRequisionIssueItem,
    handleRemoveRequisionIssueItem,
    handleRequisionIssueSubmit,
    isLoading,
  }
}

export default SRIssueFormHandleCom